import React, { Fragment } from 'react';

type SortByProps = {
    position?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SortBy = (_props:SortByProps): JSX.Element => (
  <Fragment />
);

export default SortBy;
